// extracted by mini-css-extract-plugin
export default {"container":"mluNwg","header":"RMfiZ6","headerNoSpacing":"Q6Jbmn","headerNoStartSpacing":"WsznS8","mediumHeader":"OW1qlA","largeHeader":"Laie3z","menu":"VEaC7O"};